import {css} from '@sail/engine/deprecated';
import {linkrebrandm1} from './icons/link-rebrand-icon';
import {DefaultTheme, Theme} from './theme';

// from lib/consumer/link_app/frontend/src/theme/tokens/color.ts
export const linkColors = {
  neutral400: '#8D95A1',
  neutral800: '#1d3944',
  brand: '#00D66F',
  brand50: '#E6FFED',
  brand75: '#B3FECF',
  brand100: '#5EEE97',
  brand200: '#00D66F',
  brand300: '#00C767',
  brand400: '#00A355',
  brand500: '#008545',
  brand600: '#006635',
  brand700: '#034F28',
  brand800: '#023B1E',
  brand900: '#011E0F',
};

export const LinkTheme: Theme = {
  ...DefaultTheme,
  brandColor: linkColors.brand200,
  onBrandTextColor: linkColors.brand900,
  ctaColor: linkColors.brand200,
  ctaHoverColor: linkColors.brand100,
  onCtaTextColor: linkColors.brand900,
  textColor: linkColors.neutral800,
  linkColor: linkColors.brand500,
  avatarGradientStart: linkColors.brand200,
  avatarGradientEnd: linkColors.brand200,
  focusVisibleOutline: css.value(`2px solid ${linkColors.brand200}`),
  icon: linkrebrandm1,
  messageKey: 'link',
};
